
 
export const FETCH_INDUSTRIES_REQUEST = 'industries/FETCH_INDUSTRIES_REQUEST';
export const FETCH_INDUSTRIES_SUCCESS = 'industries/FETCH_INDUSTRIES_SUCCESS';
export const FETCH_INDUSTRIES_FAILURE = 'industries/FETCH_INDUSTRIES_FAILURE';

 
export const FETCH_INDUSTRY_REQUEST = 'industries/FETCH_INDUSTRY_REQUEST';
export const FETCH_INDUSTRY_SUCCESS = 'industries/FETCH_INDUSTRY_SUCCESS';
export const FETCH_INDUSTRY_FAILURE = 'industries/FETCH_INDUSTRY_FAILURE';

 
export const DELETE_INDUSTRY_REQUEST = 'industries/DELETE_INDUSTRY_REQUEST';
export const DELETE_INDUSTRY_SUCCESS = 'industries/DELETE_INDUSTRY_SUCCESS';
export const DELETE_INDUSTRY_FAILURE = 'industries/DELETE_INDUSTRY_FAILURE';

 
export const CREATE_INDUSTRY_REQUEST = 'industries/CREATE_INDUSTRY_REQUEST';
export const CREATE_INDUSTRY_SUCCESS = 'industries/CREATE_INDUSTRY_SUCCESS';
export const CREATE_INDUSTRY_FAILURE = 'industries/CREATE_INDUSTRY_FAILURE';

 
export const UPDATE_INDUSTRY_REQUEST = 'industries/UPDATE_INDUSTRY_REQUEST';
export const UPDATE_INDUSTRY_SUCCESS = 'industries/UPDATE_INDUSTRY_SUCCESS';
export const UPDATE_INDUSTRY_FAILURE = 'industries/UPDATE_INDUSTRY_FAILURE';


export const UPDATE_FIELD = 'industries/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'industries/SET_DEFAULT_DATA';
